import React, { useId, useRef } from "react";
import {
  Backdrop,
  Button,
  CircularProgress,
  Grid,
  SwipeableDrawer,
  List,
  TablePagination,
  CardActions,
  MenuItem,
  DialogTitle,
} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Tooltip from "@material-ui/core/Tooltip";
import useStyles from "../../../themes/style.js";
import { useState, useEffect } from "react";
import EditIcon from "@material-ui/icons/Edit";
import DescriptionIcon from "@material-ui/icons/Description";
import axios from "axios";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  InputLabel,
  TextField,
  TextareaAutosize,
  Typography,
  Card,
  CardContent,
  CardMedia as CardHeader,
  Chip,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useForm, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { IoAdd, IoRemove } from "react-icons/io5";
import Switch from "@material-ui/core/Switch";
import { useLocation } from "react-router-dom";
import { useNotification } from "../../../hooks/useNotification.js";
import { makeStyles } from "@material-ui/core/styles";
import { MdEdit } from "react-icons/md";
import moment from "moment";
import { jwtDecode } from "jwt-decode";
import NoDataFound from "../../../components/NoDataFound/index.js";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import { getFileExtension } from "../../../utils/getextension.js";
import { MdDelete } from "react-icons/md";

import CloseIcon from "@material-ui/icons/Close";
import CustomPdfView from "../../../components/pdfViewer/CustomPdfView.js";

const AdminLoanManagement = () => {
  const classes = useStyles();

  const [loader, setLoader] = useState(false);
  const token = localStorage.getItem("token");
  const [currerntPage, setCurrerntPage] = useState(1);
  const [count, setCount] = useState(0);

  const [roleName, setRoleName] = useState("");

  const location = useLocation();

  const [loanDetails, setLoanDetails] = useState([]);
  const [editAssetDetails, setEditAssetDetails] = useState([]);
  const handleNotificationCall = useNotification();
  const mobileQuery = useMediaQuery("(max-width:600px)");
  const [loanDocumentURL, setLoanDocumentURL] = useState("");
  const [loanDoument, setLoanDoument] = useState(false);
  const [viewLoanDetailsModal, setViewLoanDetailsModal] = useState(false);
  const [viewLoanDetails, setViewLoanDetails] = useState({});
  const [dataList, setDataList] = useState("");
  const [page, setPage] = useState(0);
  const [allUserName, setAllUserName] = useState([]);
  const [recruiterId, setRecruiterId] = useState(null);
  const decode = jwtDecode(token);
  const companyType = decode?.companyType;
  const [confimationOpen, setConfimationOpen] = useState(false);
  const [deleteLoanDetail, setDeleteLoanDetail] = useState("");

  const handleConfirmationModalOpen = (id) => {
    setConfimationOpen(true);
    setDeleteLoanDetail(id);
  };

  async function handleDeleteLoanDetail() {
    const id = deleteLoanDetail;

    try {
      setLoader(true);

      const response = await axios.delete(
        `${process.env.REACT_APP_SERVER}loan/deleteLoan/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        setDeleteLoanDetail("");
        handleConfirmationModalClose();
        fetchData();
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  }

  const handleConfirmationModalClose = () => {
    setConfimationOpen(false);
  };

  function handleSidebarView(item, name) {
    // setViewLoanDetailsModal((prev) => !prev);
    setViewLoanDetails(item);
    if (name === "EDIT") {
      setDataList("EDIT");
      editSetValue("reason", item.reason);
    } else {
      setDataList("VIEW");
    }
    setState({ ...state, right: true });
  }

  const getAllUserList = async () => {
    try {
      setLoader(true);

      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}auth/getAllUserList`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        const responseData = response.data.data;
        const userList = responseData.filter((item) => item.fullName !== null);
        setAllUserName(userList);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const HeaderElements = () => <>Total : {count}</>;

  const queryParams = new URLSearchParams(location.search);

  const userID = queryParams.get("userId");
  console.log(userID);

  const handleLoanDocumentOpen = (url) => {
    setLoanDoument(true);
    setLoanDocumentURL(process.env.REACT_APP_AWS_BUCKET_URL + url);
  };

  const handleLoanDocumentClose = () => {
    setLoanDoument(false);
  };

  const [state, setState] = useState({
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    setState({ ...state, [anchor]: open });
  };

  // const validationSchema = Yup.object().shape({
  //   userAssests: Yup.array().of(
  //     Yup.object().shape({
  //       userId: Yup.string(),
  //       assetName: Yup.string().required("Asset Name is required"),
  //       assetType: Yup.string().required("Asset Type is required"),
  //       assetDescription: Yup.string().required(
  //         "Asset Description is required",
  //       ),
  //     }),
  //   ),
  // });

  const editValidationSchema = Yup.object().shape({
    reason: Yup.string().notRequired("Reason is required"),
    document: Yup.mixed()
      .notRequired()
      .test("fileType", "Only PDF or Word documents are allowed", (value) => {
        console.log("Value in fileType test:", value);

        if (!value || value.length == 0) return true;

        const fileValue = value instanceof FileList ? value[0] : value;

        if (!fileValue || !fileValue.type) return false;

        return [
          "application/pdf",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ].includes(fileValue.type);
      })
      .test("fileSize", "File size should not exceed 2MB", (value) => {
        console.log("Value in fileSize test:", value);

        if (!value || value.length == 0) return true;

        const fileValue = value instanceof FileList ? value[0] : value;

        if (!fileValue || !fileValue.size) return false;

        return fileValue.size <= 2 * 1024 * 1024;
      }),
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoader(true);

    try {
      const viewAlldata = await axios.get(
        `${process.env.REACT_APP_SERVER}loan/viewAllLoans?page=${currerntPage}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        },
      );
      if (viewAlldata.data.status) {
        setLoanDetails(viewAlldata.data.data);
        setLoader(false);

        setCount(viewAlldata.data.count);
        getAllUserList();
      } else {
        handleNotificationCall("error", viewAlldata.data.message);
      }
    } catch (error) {
      console.log(error);
      handleNotificationCall("error", "Error Happend!");
    } finally {
      setLoader(false);
    }
  };

  async function handleAdd(values) {
    console.log("Data Added out Api");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}assets/addAssets`,
        {
          userAssests: values.userAssests,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );
      setLoader(false);

      if (response.data.status === true) {
        handleNotificationCall("success", response.data.message);
        editReset();

        fetchData();
        console.log("Data Added in Api");
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  }

  async function handleEdit(values) {
    const id = viewLoanDetails.id;

    console.log(values, values.document[0]);
    try {
      setLoader(true);
      const data = {
        id: id,
        document: values.document[0],
        reason: values.reason,
      };
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}loan/editLoan`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: token,
          },
        },
      );
      setLoader(false);

      if (response.data.status === true) {
        handleNotificationCall("success", response.data.message);
        editReset();
        toggleDrawer("right", false)();
        fetchData();
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  }

  function getEmpName(user) {
    let empName;
    if (user?.employee) {
      empName = user.employee.firstName + " " + user.employee.lastName;
    }

    if (user?.recruiter) {
      empName = user.recruiter.firstName + " " + user.recruiter.lastName;
    }
    return empName;
  }

  // const handleStatusChange = async (e) => {
  //   console.log(e.target.checked);
  //   editSetValue("assetStatus", e.target.checked);
  //   setEditAssetDetails({
  //     ...editAssetDetails,
  //     assetStatus: !editAssetDetails.assetStatus,
  //   });

  //   try {
  //     const data = { id: editAssetDetails.id, userId: editAssetDetails.userId };
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_SERVER}assets/returnAsset`,
  //       data,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: token,
  //         },
  //       },
  //     );
  //     setLoader(false);

  //     if (response.data.status === true) {
  //       handleNotificationCall("success", response.data.message);
  //       editReset();
  //       fetchData();
  //     } else {
  //       handleNotificationCall("error", response.data.message);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   } finally {
  //     setLoader(false);
  //   }
  // };

  console.log(viewLoanDetails);

  // const {
  //   register,
  //   handleSubmit,
  //   reset,
  //   setValue,
  //   control,
  //   formState: { errors, isSubmitting },
  // } = useForm({
  //   resolver: yupResolver(validationSchema),
  //   defaultValues: {
  //     userAssests: [
  //       {
  //         userId: userID,
  //         assetName: "",
  //         assetType: "",
  //         assetDescription: "",
  //       },
  //     ],
  //   },
  // });

  const {
    register: editRegister,
    handleSubmit: editHandleSubmit,
    reset: editReset,
    setValue: editSetValue,
    control: editControl,
    formState: { errors: editErrors, isSubmitting: editIsSubmitting },
  } = useForm({
    resolver: yupResolver(editValidationSchema),
  });

  // const { fields, append, remove } = useFieldArray({
  //   control: editControl,
  //   name: "userAssests",
  // });

  let fileExtension = loanDocumentURL
    ? getFileExtension(loanDocumentURL)
    : null;
  console.log(fileExtension);

  const list = (anchor) =>
    dataList === "EDIT" ? (
      <Box sx={{ width: "100%" }} role="presentation">
        <List>
          <Card className={classes.root}>
            <CardHeader>
              <Grid
                container
                direction="row"
                spacing={1}
                className={classes.drawerViewHeader}
              >
                <Grid item xs={10} md={6}>
                  <Typography variant="subtitle1">Edit Loan Details</Typography>
                </Grid>

                <Grid item xs={2} md={6} className={classes.drawerViewClose}>
                  <CloseIcon
                    className={classes.closeBtn}
                    size="14px"
                    onClick={toggleDrawer(anchor, false)}
                  />
                </Grid>
              </Grid>
            </CardHeader>

            <form
              onSubmit={editHandleSubmit(handleEdit, (e) => console.log(e))}
            >
              <CardContent className={classes.drawerViewContent}>
                <Grid
                  container
                  direction="row"
                  spacing={2}
                  style={{ overflow: "scroll" }}
                >
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="reason">
                      Reason
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        classes={{ root: classes.customTextField }}
                        placeholder="Enter the Reason"
                        {...editRegister("reason")}
                        error={editErrors.reason ? true : false}
                      />

                      <Typography variant="inherit" color="error">
                        {editErrors.reason?.message}
                      </Typography>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="document">
                      Loan Document
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <div>
                        <input
                          accept=".pdf,.doc,.docx"
                          className={classes.input}
                          id="icon-button-loan-document"
                          size="small"
                          type="file"
                          style={{ display: "none" }}
                          placeholder="Select employee joining Date "
                          {...editRegister("document")}
                        />
                        <label htmlFor="icon-button-loan-document">
                          <Button
                            variant="contained"
                            className={classes.button}
                            color="primary"
                            startIcon={<DescriptionIcon />}
                            aria-label="Upload Loan Document"
                            component="span"
                          >
                            Upload Upload Loan Document
                          </Button>
                        </label>
                      </div>

                      <Typography variant="inherit" color="error">
                        {editErrors.document?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                </Grid>
              </CardContent>
              <CardActions>
                <Grid
                  container
                  direction="row"
                  spacing={2}
                  className={classes.drawerFooter}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    type="submit"
                  >
                    Edit
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    color="secondary"
                    onClick={toggleDrawer(anchor, false)}
                  >
                    Close
                  </Button>
                </Grid>
              </CardActions>
            </form>
          </Card>
        </List>
      </Box>
    ) : (
      <Box sx={{ width: "100%" }} role="presentation">
        <List>
          <Card className={classes.root}>
            <CardHeader>
              <Grid
                container
                direction="row"
                spacing={1}
                className={classes.drawerViewHeader}
              >
                <Grid item xs={10} md={6}>
                  <Typography variant="subtitle1">View Loan Details</Typography>
                </Grid>

                <Grid item xs={2} md={6} className={classes.drawerViewClose}>
                  <CloseIcon
                    className={classes.closeBtn}
                    size="14px"
                    onClick={toggleDrawer(anchor, false)}
                  />
                </Grid>
              </Grid>
            </CardHeader>

            <CardContent className={classes.drawerViewContent}>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>Name</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {getEmpName(viewLoanDetails?.user)}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Email ID:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {viewLoanDetails?.user?.email}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Principal Amount:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {"₹" + viewLoanDetails.principalAmount?.toLocaleString()}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Amount of Interest:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {"₹" + viewLoanDetails.amountOfInterest?.toLocaleString()}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Interest Rate:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {viewLoanDetails.interestRate + "%"}
                </Grid>

                {viewLoanDetails.reason && (
                  <>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <Typography className={classes.boldtext}>
                        Reason:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      {viewLoanDetails.reason}
                    </Grid>
                  </>
                )}

                {viewLoanDetails.loanDocument && (
                  <>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <Typography className={classes.boldtext}>
                        Loan Document:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <Tooltip
                        title="View Loan Document"
                        placement="bottom"
                        aria-label="View"
                      >
                        <RemoveRedEyeIcon
                          className={classes.toolIcon}
                          onClick={() =>
                            handleLoanDocumentOpen(viewLoanDetails.loanDocument)
                          }
                        />
                      </Tooltip>
                    </Grid>
                  </>
                )}

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Duration:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {viewLoanDetails.amountOfTime +
                    `${
                      viewLoanDetails.amountOfTime <= 1 ? " Month" : " Months"
                    }`}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Remaining Balance:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {"₹" + viewLoanDetails.remainingBalance?.toLocaleString()}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Amound Paid :
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {"₹" + viewLoanDetails.amountPaid?.toLocaleString()}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>Status</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Button
                    className={
                      viewLoanDetails?.loanStatus === "INPROGRESS"
                        ? classes.yellow
                        : classes.green
                    }
                  >
                    {viewLoanDetails.loanStatus}
                  </Button>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Paid Dues:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {viewLoanDetails.noOfGivenTime +
                    `${
                      viewLoanDetails.noOfGivenTime <= 1 ? " Month" : " Months"
                    }`}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Remaining Dues:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {viewLoanDetails.remainingTime +
                    `${
                      viewLoanDetails.remainingTime <= 1 ? " Month" : " Months"
                    }`}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Due Amount:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {"₹" + viewLoanDetails.singleTimeAmount?.toLocaleString()}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Posted On:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {moment(viewLoanDetails.createdAt).format("DD-MM-YYYY")}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Modified On:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {moment(viewLoanDetails.updatedAt).format("DD-MM-YYYY")}
                </Grid>
              </Grid>
            </CardContent>
            <CardActions>
              <Grid
                container
                direction="row"
                spacing={2}
                className={classes.drawerFooter}
              >
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  onClick={toggleDrawer(anchor, false)}
                >
                  Close
                </Button>
              </Grid>
            </CardActions>
          </Card>
        </List>
      </Box>
    );

  const filterRef = useRef(null);

  // const handleFromDateChange = (event) => {
  //   setFromDate(filterRef.current.fromDate.value);
  // };

  // const handleToDateChange = (event) => {
  //   setToDate(filterRef.current.toDate.value);
  // };

  const resetForm = (e) => {
    filterRef.current.reset();
    setRoleName("");
    setRecruiterId("");
    fetchData();
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setCurrerntPage(newPage + 1);
    setLoader(true);

    let url = "";

    if (recruiterId.id) {
      url = `${process.env.REACT_APP_SERVER}loan/viewAllLoans?userId=${recruiterId.id}&page=${currerntPage}`;
    } else {
      url = `${process.env.REACT_APP_SERVER}loan/viewAllLoans?page=${currerntPage}`;
    }

    axios({
      method: "post",
      url: url,

      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setLoanDetails(response.data.data);
        setCount(response.data.count);
        setLoader(false);
      }

      setLoader(false);
    });
  };

  function getFilterData() {
    setLoader(true);
    setCurrerntPage(1);
    setPage(0);
    const form = filterRef.current;

    const userID = recruiterId?.id;
    if (userID) {
      try {
        setLoader(true);
        axios({
          method: "get",
          url: `${process.env.REACT_APP_SERVER}loan/viewAllLoans?userId=${userID}&page=${currerntPage}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }).then(function (response) {
          if (response?.data?.status === true) {
            setLoader(false);
            setCount(response?.data?.count);
            setLoanDetails(response.data.data);
          }
        });
      } catch (error) {
        console.log(error);
        setLoader(false);
      }
    } else {
      fetchData();
    }

    
  }

  return (
    <>
      <Box display="flex" justifyContent="flex-end" mt={2}>
        <Button
          variant="contained"
          color="primary"
          size="small"
          // onClick={handleLoanDocumentOpen}
        >
          Add New Loan
        </Button>
      </Box>

      <form
        ref={filterRef}
        onSubmit={(e) => {
          e.preventDefault();
          getFilterData();
        }}
      >
        <Grid container spacing={2} className={classes.filterGap}>
         
          <Autocomplete
            className={classes.filterFullWidth}
            options={allUserName}
            getOptionLabel={(option) => {
              const roleName = option.role?.roleName;
              let label = option.fullName;

              return label;
            }}
            onChange={(event, value) => {
              setRecruiterId(value);
            }}
            defaultValue=""
            value={recruiterId}
            size="small"
            renderInput={(params) => (
              <TextField
                {...params}
                name="recruiterId"
                variant="standard"
                label={companyType === "COMPANY" ? "User" : "Recruiter"}
                InputLabelProps={{ shrink: true }}
                type="text"
              />
            )}
          />

     

          <div className={classes.buttons}>
            <Button
              variant="contained"
              size="small"
              type="submit"
              color="primary"
            >
              Search
            </Button>
            <Button
              variant="contained"
              size="small"
              color="secondary"
              onClick={() => resetForm()}
            >
              Reset
            </Button>
          </div>
        </Grid>
      </form>

      <MUIDataTable
        title=""
        options={{
          textLabels: {
            body: {
              noMatch: "Oops! Matching record could not be found",
            },
          },
          pagination: false,
          sort: false,
          selectableRows: "none",
          search: false,
          filter: false,
          download: false,
          print: false,
          customToolbar: () => <HeaderElements />,
          responsive: mobileQuery === true ? "vertical" : "standard",
        }}
        columns={[
          {
            name: "S.No",
          },
          {
            name: "Name",
          },
          {
            name: "Email ID",
          },
          {
            name: "Principal Amount",
          },
          {
            name: "Amount Of Interest",
          },
          {
            name: "Duration",
          },
          {
            name: "Remaining Balance",
          },
          {
            name: "Amound Paid",
          },
          {
            name: "Status",
          },
          {
            name: "Action",
          },
        ]}
        data={loanDetails.map((item, index) => {
          return [
            <>
              {currerntPage !== 0
                ? 10 * currerntPage - 10 + index + 1
                : index + 1}
            </>,
            getEmpName(item?.user),
            item?.user.email,
            "₹" + item?.principalAmount?.toLocaleString(),
            "₹" + item?.amountOfInterest?.toLocaleString(),
            `${item?.amountOfTime}${
              item?.amountOfTime === 1 ? " Month" : " Months"
            }`,
            "₹" + item?.remainingBalance?.toLocaleString(),
            "₹" + item?.amountPaid?.toLocaleString(),
            <Button
              className={
                item?.loanStatus === "INPROGRESS"
                  ? classes.yellow
                  : classes.green
              }
            >
              {item?.loanStatus === "INPROGRESS" ? "IN PROGRESS" : ""}
            </Button>,
            <Grid container className={classes.space}>
              <Grid item xs={12} className={classes.toolAlign}>
                <Tooltip
                  title="View Loan detail"
                  placement="bottom"
                  aria-label="view"
                >
                  <RemoveRedEyeIcon
                    className={classes.toolIcon}
                    onClick={() => handleSidebarView(item, "VIEW")}
                    style={{ marginRight: "10px" }}
                  />
                </Tooltip>

                <Tooltip
                  title="Edit Loan detail"
                  placement="bottom"
                  aria-label="edit"
                >
                  <EditIcon
                    className={classes.toolIcon}
                    onClick={() => handleSidebarView(item, "EDIT")}
                    style={{ marginRight: "10px" }}
                  />
                </Tooltip>
                <Tooltip
                  title="Delete Loan detail"
                  placement="bottom"
                  aria-label="edit"
                >
                  <MdDelete
                    className={classes.toolIconDelete}
                    onClick={() => handleConfirmationModalOpen(item.id)}
                  />
                </Tooltip>
              </Grid>
            </Grid>,

            // moment(item?.created).format("DD-MM-YYYY"),
            // moment(item?.updatedAt).format("DD-MM-YYYY")
          ];
        })}
      />
      <Grid container spacing={2} className={classes.pagination}>
        <TablePagination
          rowsPerPageOptions={[10]}
          component="div"
          count={count}
          rowsPerPage={10}
          page={page}
          onPageChange={handleChangePage}
        />
      </Grid>

      <Dialog
        aria-labelledby="dialog-title"
        // onClose={handleModalClose}
        open={loanDoument}
        fullWidth={true}
        maxWidth="md"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        <DialogContent>
          <Grid container direction="row" spacing={2}>
            <div
              className={`${classes.heading} ${classes.inputRoot} ${classes.pdfModalTitleText}`}
            >
              <Typography variant="subtitle2" className={classes.inputRoot}>
                Loan Document
              </Typography>
              <div className={classes.pdfModalCloseBtn}>
                <CloseIcon
                  className={classes.closeBtn}
                  onClick={handleLoanDocumentClose}
                />
              </div>
            </div>
            <Grid item xs={12} height="500">
              {fileExtension === "pdf" ? (
                <CustomPdfView resumeUrl={loanDocumentURL} />
              ) : (
                <div
                  className={classes.iframediv}
                  style={{ marginTop: "40px" }}
                >
                  <iframe
                    src={
                      "https://docs.google.com/a/umd.edu/viewer?url=" +
                      loanDocumentURL +
                      "&embedded=true"
                    }
                    title="File"
                    width="100%"
                    height="500"
                    sandbox="allow-scripts allow-same-origin"
                  ></iframe>
                  <div className={classes.iframeLogo}></div>
                </div>
              )}
            </Grid>
            <div className={classes.sendWhatsapp + " " + classes.inputRoot}>
              <Button
                variant="contained"
                size="small"
                color="secondary"
                onClick={handleLoanDocumentClose}
              >
                Close
              </Button>
            </div>
          </Grid>
        </DialogContent>
      </Dialog>

      <Grid item xs={3} sm={5} md={4} lg={6} className={classes.drawerClose}>
        <SwipeableDrawer
          anchor="right"
          open={state["right"]}
          onClose={toggleDrawer("right", false)}
          onOpen={toggleDrawer("right", true)}
          classes={{ paper: classes.drawer }}
        >
          {list("right")}
        </SwipeableDrawer>
      </Grid>

      <Dialog
        onClose={handleConfirmationModalClose}
        aria-labelledby="dialog-title"
        open={confimationOpen}
        width="md"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        <DialogTitle className={classes.digTitle}>
          <div className={classes.center}>
            <Typography
              variant="subtitle2"
              className={classes.digColor + " " + classes.digCenter}
            >
              Confirmation
            </Typography>

            <div className={classes.drawerClose}>
              <CloseIcon
                className={classes.digClose}
                onClick={handleConfirmationModalClose}
                size="14px"
              />
            </div>
          </div>
        </DialogTitle>

        <DialogContent className={classes.chatListBackGround}>
          <Typography variant="subtitle2">
            Do you want to delete this loan detail?
          </Typography>
          <div className={classes.sendWhatsapp}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleDeleteLoanDetail}
            >
              Yes
            </Button>

            <Button
              variant="contained"
              size="small"
              color="secondary"
              onClick={handleConfirmationModalClose}
            >
              No
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default AdminLoanManagement;
